import { Component, OnInit, OnDestroy } from '@angular/core';
import { Game } from '../models/game.model';
import { Subscription } from 'rxjs';
import { GamesService } from '../services/games.service';
import { Router } from '@angular/router';
import * as firebase from 'firebase';

@Component({
  selector: 'app-game-list',
  templateUrl: './game-list.component.html',
  styleUrls: ['./game-list.component.scss']
})

export class GameListComponent implements OnInit, OnDestroy {

  //var auth
  isAuth = false;
  viewAuthFunction = false;

  //var games
  games: Game[];
  gamesSubscription : Subscription;

  //var categorie
  catEstaminet = true;
  catAdresse = false;
  catGeants = false;
  catEnfant = false;
  catComptoir = false;
  catCasseTete = false;
  catExterieur = false;
  catCasino = false;
  catSociete = false;
  catReflexion = false;
  catHasard = false;
  catCooperatif = false;
  
  catAll = false;


  constructor(private gamesService: GamesService,
              private router: Router) { }


  // ################################ Init Function ################################
  // ################################ Init Function ################################
  // ################################ Init Function ################################


  ngOnInit() {
    window.scrollTo(0,0);

    //auth ngOnInit (detect auth connection)
    firebase.auth().onAuthStateChanged(
      (user) => {
        if(user) {
          this.isAuth = true;
        } else {
          this.isAuth = false;
        }
      }
    )

    //games ngOnInit
    this.gamesSubscription = this.gamesService.gamesSubject.subscribe(
      (games: Game[]) => {
        this.games = games;

        //sort game by alphabet order TO REMOVE
        //this.games.sort((a, b) => (a.title > b.title) ? 1 : -1);
      }
    );
    this.gamesService.getGames();
    this.gamesService.emitGames();
  }

  // ################################ Auth Function ################################
  // ################################ Auth Function ################################
  // ################################ Auth Function ################################

  onNewGame() {
    this.router.navigate(['/games','new'])
  }

  onDeletGame(game: Game){
    var confirmDelet = confirm("Cette action entrainera la suppression deffinitive du jeu. Voulez-vous continuer ? ");
    if(this.isAuth && confirmDelet){
      this.gamesService.removeGame(game);
    }
  }

  onViewAuthFunction(){
    this.viewAuthFunction = !this.viewAuthFunction
  }
  onDontViewAuthFunction(){
    this.viewAuthFunction = false;
  }

  onVisibleGame(game: Game){
    game.visible = !game.visible;
    this.gamesService.saveGames();
    this.gamesService.emitGames();
  }  

  onEditGame(game: Game){
    this.router.navigate(['/games', 'new', game.title]);
  }

  ngOnDestroy() {
    this.gamesSubscription.unsubscribe();
  }

  // ################################ Public Function ################################
  // ################################ Public Function ################################
  // ################################ Public Function ################################


  // ################ Nav Function ################
  // ################ Nav Function ################

  catFalse() {
    this.catAdresse = false;
    this.catEstaminet = false;
    this.catGeants = false
    this.catEnfant = false;
    this.catComptoir = false;
    this.catCasseTete = false;
    this.catExterieur = false;
    this.catCasino = false;
    this.catSociete = false;
    this.catReflexion = false;
    this.catHasard = false;
    this.catCooperatif = false;
    this.catAll = false;
  }

  getAdresse() {
    this.catFalse();
    this.catAdresse = true;
    window.scrollTo(0,0);
  }

  getEstaminet() {
    this.catFalse();
    this.catEstaminet = true;
    window.scrollTo(0,0);

  }

  getGeants() {
    this.catFalse();
    this.catGeants = true;
    window.scrollTo(0,0);
  }


  getEnfant() {
    this.catFalse();
    this.catEnfant = true;
    window.scrollTo(0,0);
  }


  getComptoir() {
    this.catFalse();
    this.catComptoir = true;
    window.scrollTo(0,0);
  }


  getCasseTete() {
    this.catFalse();
    this.catCasseTete = true;
    window.scrollTo(0,0);
  }


  getExterieur() {
    this.catFalse();
    this.catExterieur = true;
    window.scrollTo(0,0);
  }


  getCasino() {
    this.catFalse();
    this.catCasino = true;
    window.scrollTo(0,0);
  }


  getSociete() {
    this.catFalse();
    this.catSociete = true;
    window.scrollTo(0,0);
  }


  getReflexion() {
    this.catFalse();
    this.catReflexion = true;
    window.scrollTo(0,0);
  }


  getHasard() {
    this.catFalse();
    this.catHasard = true;
    window.scrollTo(0,0);
  }


  getCooperatif() {
    this.catFalse();
    this.catCooperatif = true;
    window.scrollTo(0,0);
  }



  getAll(){
    this.catFalse();
    this.catAll = true;
    window.scrollTo(0,0);
  }

  displayGame(game): boolean {

    // diplay by nav
    var byNav = false;

    var gCatAdresse    = game.categorie['catAdresse'];
    var gCatEstaminet  = game.categorie['catEstaminet'];
    var gCatGeants     = game.categorie['catGeants'];
    var gCatEnfant     = game.categorie['catEnfant'];
    var gCatComptoir   = game.categorie['catComptoir'];
    var gCatCasseTete  = game.categorie['catCasseTete'];
    var gCatExterieur  = game.categorie['catExterieur'];
    var gCatCasino     = game.categorie['catCasino'];
    var gCatSociete    = game.categorie['catSociete'];
    var gCatReflexion  = game.categorie['catReflexion'];
    var gCatHasard     = game.categorie['catHasard'];
    var gCatCooperatif = game.categorie['catCooperatif'];

         if ( this.catAll ) {return true}
    else if ( this.catAdresse    === true && gCatAdresse    === true) {byNav = true}
    else if ( this.catEstaminet  === true && gCatEstaminet  === true) {byNav = true}
    else if ( this.catGeants     === true && gCatGeants     === true) {byNav = true}
    else if ( this.catEnfant     === true && gCatEnfant     === true) {byNav = true}
    else if ( this.catComptoir   === true && gCatComptoir   === true) {byNav = true}
    else if ( this.catCasseTete  === true && gCatCasseTete  === true) {byNav = true}
    else if ( this.catExterieur  === true && gCatExterieur  === true) {byNav = true}
    else if ( this.catCasino     === true && gCatCasino     === true) {byNav = true}
    else if ( this.catSociete    === true && gCatSociete    === true) {byNav = true}
    else if ( this.catReflexion  === true && gCatReflexion  === true) {byNav = true}
    else if ( this.catHasard     === true && gCatHasard     === true) {byNav = true}
    else if ( this.catCooperatif === true && gCatCooperatif === true) {byNav = true}
    else { byNav = false};

    // display by auth
    var byAuth = false;
    if (this.isAuth || game.visible) {byAuth = true}
    
    // return final display
    return byNav && byAuth

  }



  // ################ game Function ################
  // ################ game Function ################
  
  onViewGame(game: Game) {
    this.router.navigate(['/games', 'view', game.title]);
  }













}
